var path = '/modules/guestlists/views/modals/studio-modal.tpl.html';
var html = "<div class=\"modal-dialog studio-iframe-modal\">\n    <div class=\"modal-content\">\n        <button class=\"close ng-scope\" ng-click=\"vm.dismiss()\"><i class=\"fal fa-times\"></i></button>\n        <div class=\"modal-header\">\n            <h2>Edit your landingpage</h2>\n        </div>\n        <div class=\"modal-body\">\n            <iframe id=\"studio-iframe\"/>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/guestlists/views/modals/studio-modal.tpl.html
// module id = 2127
// module chunks = 1